module.exports = __webpack_public_path__ + "14_ldav.pdf?bc91d8d571dfdf9f0f5898d117310933";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperData/14_ldav.pdf
// module id = 136
// module chunks = 0